module.exports = __webpack_public_path__ + "assets/img/4.67f2b9ae.jpg";